import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  UntypedFormControl,
  NG_VALUE_ACCESSOR,
  NgControl,
  ValidatorFn,
  Validator,
  ValidationErrors,
  NG_VALIDATORS,
  FormArray,
  FormControl,
} from '@angular/forms';
import { DestroySubscribers } from '../../../decorators/destroy-subscribers.decorator';
import { getReplayControlValueChange } from '../../../helpers/replay-control';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'gtd-ui-form-field-multiple-text',
  templateUrl: './multiple-text.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultipleTextComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MultipleTextComponent),
      multi: true,
    },
  ],
})
@DestroySubscribers()
export class MultipleTextComponent implements ControlValueAccessor, OnInit, AfterViewInit, Validator {
  @Input() label: any;
  @Input() cssClass!: string;
  @Input() message!: string;
  @Input() hint!: string;
  @Input() validator?: ValidatorFn | ValidatorFn[];

  public isDisabled!: boolean;
  public isRequired!: boolean;
  public formArray = new FormArray<FormControl<any>>([]);

  private onChange!: (value: any) => void;
  private onTouch!: () => void;
  private subscribers: any = {};

  constructor(private cdr: ChangeDetectorRef, private injector: Injector) {}

  ngOnInit() {
    this.subscribers.values = getReplayControlValueChange(this.formArray).subscribe((values: string[]) => {
      const value = values.filter((el) => el);
      this.onChange(value);
      this.onTouch();
    });
  }

  ngAfterViewInit() {
    const { control } = this.injector.get(NgControl);
    this.isRequired = control?.validator && control?.validator({} as AbstractControl)?.['required'];
  }

  createField() {
    this.formArray.push(new UntypedFormControl(null, this.validator));
  }

  deleteField(index: number) {
    this.formArray.removeAt(index);
  }

  trackByFn(_index: number, control: AbstractControl) {
    return control;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  writeValue(values?: string[]): void {
    if (Array.isArray(values)) {
      for (const value of values) {
        this.formArray.push(new UntypedFormControl(value));
      }
    }
    if (this.isRequired && !this.formArray.length) {
      this.createField();
    }
    this.cdr.markForCheck();
  }

  public validate(): ValidationErrors | null {
    switch (true) {
      case this.formArray.invalid:
        return { errors: true };
      default:
        return null;
    }
  }
}
